'use client';

import { useBrandId } from '@/lib/brand/context';

// Import brand-specific Logo components
import * as CareerOffensiveLogo from '@/components/brands/careeroffensive/Logo';

const BrandLogos = {
  careeroffensive: CareerOffensiveLogo,
};

export const Logo = ({ className }: { className?: string }) => {
  const brandId = useBrandId();
  const BrandLogo = BrandLogos[brandId as keyof typeof BrandLogos];

  return <BrandLogo.Logo className={className} />;
};

export const Logomark = ({ className }: { className?: string }) => {
  const brandId = useBrandId();
  const BrandLogo = BrandLogos[brandId as keyof typeof BrandLogos];

  return <BrandLogo.Logomark className={className} />;
};

export default Logomark;